var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeovector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0167611 7.35546C-0.263331 4.14088 3.00589 1.59544 6.909 1.9986C7.00393 2.00834 7.02713 2.15706 6.93314 2.17393C3.74506 2.74685 2.75571 7.49441 0.438886 7.6383C0.233044 7.65113 0.0346614 7.56092 0.0167611 7.35546Z",
    fill: "#EFA73F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0167611 7.35546C0.0247291 7.44682 0.0695791 7.51412 0.133654 7.56092C0.58924 7.82389 1.36145 7.06253 1.87237 5.47327C2.62175 3.14195 4.91518 2.0488 6.909 1.9986C3.00589 1.59544 -0.263331 4.14088 0.0167611 7.35546Z",
    fill: "#5AB2AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35515 13.9832C4.14071 14.2634 1.59537 10.994 1.99852 7.0907C2.00829 6.99576 2.15693 6.97261 2.17379 7.06655C2.74669 10.2548 7.49409 11.2442 7.63797 13.5611C7.65075 13.7669 7.56059 13.9653 7.35515 13.9832Z",
    fill: "#5AB2AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35515 13.9832C7.44643 13.9753 7.51375 13.9304 7.56059 13.8663C7.82356 13.4107 7.06223 12.6384 5.47303 12.1276C3.14182 11.3781 2.04871 9.08461 1.99852 7.0907C1.59537 10.994 4.14071 14.2634 7.35515 13.9832Z",
    fill: "#4E9E8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9832 6.64536C14.2634 9.85998 10.9941 12.4054 7.091 12.0023C6.99606 11.9925 6.97291 11.8438 7.06685 11.8269C10.255 11.254 11.2443 6.50645 13.5611 6.36251C13.767 6.34973 13.9653 6.4399 13.9832 6.64536Z",
    fill: "#EFA73F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9826 6.64543C13.9747 6.55407 13.9299 6.48682 13.8658 6.43998C13.4101 6.177 12.6379 6.93836 12.127 8.52763C11.3776 10.8589 9.08418 11.9521 7.09036 12.0023C10.9935 12.4055 14.2627 9.86005 13.9826 6.64543Z",
    fill: "#5AB2AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64447 0.0167618C9.85891 -0.263343 12.4042 3.00602 12.0011 6.9093C11.9914 7.00423 11.8426 7.02743 11.8258 6.93349C11.2529 3.74522 6.50553 2.7558 6.36164 0.438949C6.34886 0.233054 6.43903 0.0346629 6.64447 0.0167618Z",
    fill: "#5AB2AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64447 0.0167618C6.55312 0.0247301 6.48593 0.069538 6.4391 0.13366C6.17613 0.589265 6.9375 1.36151 8.52672 1.87245C10.8579 2.62187 11.9509 4.91543 12.0011 6.9093C12.4042 3.00602 9.85891 -0.263343 6.64447 0.0167618Z",
    fill: "#4E9E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeovector);
export default __webpack_public_path__ + "static/media/deovector.e6f646676b25dfbe983e583ee2e8ba60.svg";
export { ForwardRef as ReactComponent };